import api from "../../../../api";
import React, { useState } from "react";
import values from "../../../../values";
import Context from "../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import { ICreateAndUpdateUser } from "../../../../types/common.interface";
import {
  CustomButton2,
  CustomCheckBox,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../components";

import "./index.scss";
import validations from "../../../../validations";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction, isLoading } =
    React.useContext(Context.UserScreen);

  const [access, setAccess] = useState<any>({
    financial: false,
    write: false,
  });

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateUser>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: "",
      firstName: "",
      lastName: "",
    },
    validationSchema: Yup.object({
      // validation
      phoneNumber: validations.yupValidations.phoneNumber,
      firstName: validations.yupValidations.firstName,
      lastName: validations.yupValidations.lastName,
    }),
    onSubmit: (values: ICreateAndUpdateUser, { setSubmitting }) => {
      const formValues: ICreateAndUpdateUser = {
        ...values,
        permission: access,
      };
      Promise.resolve(createFunction(formValues))
        .then(() => {
          formik.resetForm();
        })
        .catch((e) => setSubmitting(false));
    },
  });

  const submitHandler = () => {
    formik.submitForm();
  };

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <form onSubmit={submitHandler} id="create-user-modal">
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "CREATE"}
        >
          <CustomView.Container className="create-form-content">
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="firstName"
                  id="firstName"
                  label={t("firstName")}
                  value={formik.values.firstName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.firstName && formik.touched.firstName}
                  errorText={formik.errors.firstName}
                  placeHolder={t("firstName")}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="lastName"
                  id="lastName"
                  label={t("lastName")}
                  value={formik.values.lastName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.lastName && formik.touched.lastName}
                  errorText={formik.errors.lastName}
                  placeHolder={t("lastName")}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("phoneNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.phoneNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                  placeHolder={t("phoneNumber")}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum dropdown">
                <div className="access-container">
                  <div className="input-label right">{t("access")}</div>
                  <div>
                    <CustomCheckBox
                      label={t("financial")}
                      isChecked={access.financial}
                      onChecked={() =>
                        setAccess({ ...access, financial: !access.financial })
                      }
                    />{" "}
                    <CustomCheckBox
                      label={t("update")}
                      isChecked={access.write}
                      onChecked={() =>
                        setAccess({ ...access, write: !access.write })
                      }
                    />
                  </div>
                </div>
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={submitHandler}
                  title={t("submit")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Create;
